<template>
    <v-app id="inspire">
        <v-app-bar
                app
                color="#117ABE"
                dark
                height="90"
        >
            <v-toolbar-title>
                <a href="https://www.tele-tie.ru/" class="logo"></a>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-title class="text-center">
                <div class="text-subtitle-2">Служба&nbsp;поддержки</div>
                <div class="text-h6 font-weight-bold"><a href="tel:74951258888" class="phone">8&nbsp;495&nbsp;125&nbsp;88&nbsp;88</a></div>
                <div class="text-caption">круглосуточно</div>
            </v-toolbar-title>
        </v-app-bar>

        <v-main>
            <v-form>
                <v-container>
                    <v-row dense class="rounded-xl pa-4 mt-4 filters">
                        <v-col cols="12" class="text-h6">Фильтры</v-col>
                        <v-col
                                cols="12"
                                xl="3"
                                lg="3"
                                md="6"
                                class="pr-lg-6"
                        >
                            <v-subheader class="pl-0 text-caption">Номер телефона</v-subheader>
                            <v-text-field class="pt-0"
                                          v-model="phone"
                                          name="phone"
                                          label=""
                                          placeholder="Фрагмент номера, например, 555"
                                          clearable
                            ></v-text-field>
                        </v-col>

                        <v-col
                                class="align-start pl-lg-6"
                                cols="12"
                                xl="3"
                                lg="3"
                                md="6"
                        >
                            <v-subheader class="pl-0 text-caption">Цена</v-subheader>
                            <v-range-slider
                                    v-model="rangePrice"
                                    :max="maxPrice"
                                    :min="minPrice"
                                    hide-details
                                    class="align-end"
                                    thumb-label
                                    :thumb-size="60"
                                    step="100"
                            >
                                <template v-slot:thumb-label="item">
                                    {{item.value | price}} &#8381;
                                </template>
                                <template v-slot:prepend>
                                    <v-text-field
                                            :value="rangePrice[0]"
                                            class="mt-0 pt-0 mb-3 centered"
                                            hide-details
                                            single-line
                                            type="number"
                                            style="width: 60px"
                                            @input="setRangePrice(rangePrice, 0, $event)"
                                    ></v-text-field>
                                </template>
                                <template v-slot:default>
                                    <div class="mb-n3">
                                        <slot></slot>
                                    </div>
                                </template>
                                <template v-slot:append>
                                    <v-text-field
                                            :value="rangePrice[1]"
                                            class="mt-0 pt-0 mb-3 centered"
                                            hide-details
                                            single-line
                                            type="number"
                                            style="width: 60px"
                                            @input="setRangePrice(rangePrice, 1, $event)"
                                    ></v-text-field>
                                </template>
                            </v-range-slider>
                        </v-col>

                        <v-col
                                cols="12"
                                xl="6"
                                lg="6"
                                md="12"
                        >

                            <v-card
                                    class="d-flex flex-wrap justify-center justify-md-end"
                                    color="lighten-2"
                                    flat
                                    tile
                            >

                                <v-card
                                        class="pr-2 pt-0"
                                        flat
                                        tile
                                >
                                    <v-subheader class="pr-0 pl-0 text-caption">по номеру</v-subheader>
                                    <v-btn-toggle v-model="sortPhone">
<!--                                        <v-btn value="not-sorted">
                                            <v-icon medium>mdi-sort</v-icon>
                                        </v-btn>-->
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn value="sort-asc" v-on="on">
                                                    <v-icon medium>mdi-sort-ascending</v-icon>
                                                </v-btn>
                                            </template>
                                            <div class="text-caption">Сортировать по номеру, по возрастанию</div>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn value="sort-desc" v-on="on">
                                                    <v-icon medium>mdi-sort-descending</v-icon>
                                                </v-btn>
                                            </template>
                                            <div class="text-caption">Сортировать по номеру, по убыванию</div>
                                        </v-tooltip>
                                    </v-btn-toggle>
                                </v-card>
                                <v-card
                                        class="pl-2 pt-0"
                                        flat
                                        tile
                                >
                                    <v-subheader class="pl-0 align-right text-caption">по цене</v-subheader>
                                    <v-btn-toggle v-model="sortPrice">
<!--
                                        <v-btn value="not-sorted">
                                            <v-icon medium>mdi-sort</v-icon>
                                        </v-btn>
-->
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn value="sort-asc" v-on="on">
                                                    <v-icon medium>mdi-sort-ascending</v-icon>
                                                </v-btn>
                                            </template>
                                            <div class="text-caption">Сортировать по цене, по возрастанию</div>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn value="sort-desc" v-on="on">
                                                    <v-icon medium>mdi-sort-descending</v-icon>
                                                </v-btn>
                                            </template>
                                            <div class="text-caption">Сортировать по цене, по убыванию</div>
                                        </v-tooltip>
                                    </v-btn-toggle>
                                </v-card>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
            <v-container>
                <v-row>
                    <v-col cols="   12" class="text-right">
                    Количество записей: {{countNumbers}}
                    </v-col>

                </v-row>
                <large-lazy-list :value="filterNumbers" v-slot="chunk">
                    <cards :filterNumbers="chunk" :favourites="favourites" @addToFavorites="addToFavoritesHandler" @removeFromFavorites="removeFromFavoritesHandler"></cards>
                </large-lazy-list>
            </v-container>
        </v-main>

        <v-footer color="transparent" app style="bottom: 30px; pointer-events: none">
            <div class="d-flex flex-wrap" v-if="favourites.length > 0">
                <v-chip
                        v-for="(number, index) in favourites"
                        :key="index"
                        class="ma-2 text-caption"
                        close
                        color="primary"
                        text-color="white"
                        @click:close="removeFromFavoritesHandler(number)"
                        style="pointer-events: auto"
                >
                    {{number | msisdn}}
                </v-chip>
                <v-chip v-if="favourites.length > 1"
                        class="ma-2 text-caption"
                        color="red"
                        link
                        text-color="white"
                        @click="removeAllFromFavoritesHandler()"
                        style="pointer-events: auto"
                >
                    Удалить все
                </v-chip>
            </div>
        </v-footer>
        <v-footer color="#117ABE" app>
            <span class="white--text text-caption">&copy; 2012-{{ new Date().getFullYear() }}, Teletie — оператор бизнес-класса.</span>
        </v-footer>
    </v-app>
</template>

<script>
    import _ from 'lodash';
    import LargeLazyList from '@/components/LargeLazyList';
    import Cards from '@/components/Cards';

    export default {
        name: 'LayoutsDemosBaselineFlipped',
        props: {
            source: String,
        },
        components: {
            LargeLazyList,
            Cards
        },
        data: () => ({
            favourites: [],
            numbers: [],
            filterNumbers: [],
            countNumbers: 0,
            phone: '',
            minPrice: 0,
            maxPrice: 0,
            curMinPrice: 0,
            curMaxPrice: 0,
            rangePrice: [],
            // notSortedState: 'not-sorted',
            sortPhone: false,
            sortPrice: false,
            price: ''
        }),
        methods: {
            addToFavoritesHandler: function(inum) {
                if (!this.favourites.includes(inum)) {
                    this.favourites.push(inum);
                }
            },
            removeFromFavoritesHandler: function(inum) {
                const index = this.favourites.indexOf(inum);
                if (index > -1) {
                    this.favourites.splice(index, 1);
                }
            },
            removeAllFromFavoritesHandler: function() {
              this.favourites = [];
            },
            setRangePrice:  _.debounce(function (v, index, e) {
                    this.$set(v, index, e);
                }, 1000),
            getData () {
                let self = this;
                return this.$api.request({
                    url: '/change-numbers/',
                    method: 'get'
                }).then((response) => {
                    self.numbers = response.data;
                    self.numbers.map(function (item) {
                        self.curMinPrice = (item.price < self.curMinPrice) ? item.price : self.curMinPrice;
                        self.curMaxPrice = (item.price > self.curMaxPrice) ? item.price : self.curMaxPrice;
                        self.minPrice = self.curMinPrice;
                        self.maxPrice = self.curMaxPrice;
                        self.rangePrice = [self.curMinPrice, self.curMaxPrice];
                    });
                });
            },
            filterData: _.debounce(function () {
                let self = this;
                this.filterNumbers = this.sortData(this.numbers.filter(function (item) {
                    let cond = true;
                    if (self.phone && (self.phone.length > 0)) {
//                        cond &= (item.inum.indexOf(self.phone) !== -1);
                        cond &= (new RegExp(self.phone)).test(item.inum);
                    }
                    if (self.curMaxPrice > 0) {
                        cond &= ((item.price >= self.curMinPrice) && (item.price <= self.curMaxPrice));
                    }
                    return cond;
                }), this.sortIndex, this.sortDirection);
                this.countNumbers = this.filterNumbers.length;
            }, 300),
            sortData(items, index, sort) {
                if (sort && index) {
                    items.sort((a, b) => {
                        if (sort == 'sort-asc') {
                            return (a[index] < b[index]) ? -1 : 1;
                        } else {
                            return (b[index] < a[index]) ? -1 : 1;
                        }
                    });
                }
                return items;
            },
        },
        mounted: function mounted() {
            document.title = 'Телетай - замена номера';

            this.getData().then(() => {
                //
            });
        },
        computed: {
            sortIndex() {
                return !this.sortPrice === false ? 'price' : !this.sortPhone === false ? 'inum' : false;
            },
            sortDirection() {
                if (this.sortPrice) {
                    return this.sortPrice;
                } else if (this.sortPhone) {
                    return this.sortPhone;
                } else {
                    return false;
                }
            },
        },
        watch: {
            phone ()  {
                this.$nextTick(function () {
                    this.filterData();
                });
            },
            sortPrice(n/*, o*/) {
                if(n) {
                    this.sortPhone = null;
                }

                this.$nextTick(function () {
                    this.filterData();
                });
            },
            sortPhone(n/*, o*/) {
                if(n) {
                    this.sortPrice = null;
                }

                this.$nextTick(function () {
                    this.filterData();
                });
            },
            rangePrice ()  {
                this.curMinPrice = this.rangePrice[0];
                this.curMaxPrice = this.rangePrice[1];
                this.$nextTick(function () {
                    this.filterData();
                });
            },
        }

    }
</script>

<style scoped>
    /* Chrome, Safari, Edge, Opera */
    >>> input::-webkit-outer-spin-button,
    >>> input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    >>> input[type=number] {
        -moz-appearance: textfield;
    }

    .centered >>> input {
        text-align: center
    }

    >>> .v-slider__thumb-label {
        box-shadow: 0 0 32px white;
    }

    .v-subheader {
        height: auto!important;
    }

    .filters {
        background: rgba(17, 122, 190, 0.3);
    }

    .filters .v-card {
        background-color: transparent;
    }

    a.phone {
        color: white!important;
        text-decoration: none!important;
    }
</style>
